// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cnlk","content":"styles_content__3pZAW"};